import React from "react";
import styled from "styled-components";
import PerfectScrollbar from "perfect-scrollbar";
import { v2API } from "@voxmarkets/api-sdk";

import Text from "./vox-web/components/Text";
import VoxThemeProvider from "./vox-web/components/VoxThemeProvider";

import { Grid, Cell, Spacing } from "./vox-web/components/Layout";
import List from "./vox-web/components/List";
import RatioBox from "./vox-web/components/RatioBox";
import { Link } from "./vox-web/components/Utils";

import MediaItem from "./MediaItem";
import CompanyCard from "./CompanyCard";

const Header = ({ title, color }) => (
  <div className="Widget-data">
    <div className="Title" style={{ color: `rgba(${color}, 1)` }}>
      {title}
    </div>
    <div
      className="Text Text--s u-spacer-l"
      style={{ color: `rgba(${color}, 1)` }}
    >
      Powered by<strong> Vox Markets</strong>
    </div>
  </div>
);

const Widget = ({ children, style }) => (
  <div className="Widget Widget--color1" style={style}>
    {children}
  </div>
);

const Scroller = styled.div`
  overflow: hidden;
  position: relative;
  padding-bottom: 1rem;
`;

class MediaWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      company: null,
      mediaAssets : null
    };
  }

  loadData = async () => {
    let filter = null;

    if (this.props.type === "box") {
      filter = JSON.stringify({
        where: { id: this.props.mediaID }
      });
    }

    if (this.props.type === "single-cover") {
      filter = JSON.stringify({
        where: { id: this.props.mediaID }
      });
    }

    if (this.props.type === "single") {
      filter = JSON.stringify({
        where: { id: this.props.mediaID }
      });
    }
    if (this.props.type === "horizontal") {
      filter = JSON.stringify({
        where: { mediaType: { like: "video*" } },
        limit: 10
      });
    }

    if (this.props.type === "horizontal" && this.props.mediaType === "audio") {
      filter = JSON.stringify({
        where: { mediaType: { like: "audio*" } },
        limit: 10
      });
    }

    if (this.props.type === "recent" && !this.props.mediaType) {
      filter = JSON.stringify({
        limit: 1
      });
    }

    if (this.props.type === "recent" && this.props.mediaType) {
      filter = JSON.stringify({
        where: { mediaType: { like: `${this.props.mediaType}*` } },
        limit: 1
      });
    }

    if (this.props.type === "vertical" && !this.props.mediaType) {
      filter = JSON.stringify({
        limit: 20,
        where: {
          or: [
            { mediaType: { like: "video*" } },
            { mediaType: { like: "audio*" } }
          ]
        },
        order: "publishedAt DESC",
      });
    }

    if (this.props.type === "horizontal-recent") {
      filter = JSON.stringify({
        limit: 10,
        where: {
          or: [
            { mediaType: { like: "video*" } },
            { mediaType: { like: "audio*" } }
          ]
        },
        order: "publishedAt DESC",
      });
    }

    const getFirst = result => result[0];

    const listing = await v2API.AdvCompanies.getListings({
      where: { listingShortTicker: this.props.ticker.toUpperCase() }
    }).then(getFirst);

    const issue = await v2API.AdvCompanies.getIssues({
      where: { id: listing.issueId },
      include: "listings"
    }).then(getFirst);

    const company = await v2API.AdvCompanies.getCompanies({
      where: { id: issue.issueCompanyId }
    }).then(getFirst);

    this.setState({
      company,
      mediaAssets : [],
      ticker: listing.listingShortTicker
    });

    const mediaFilter = {
      where : {
        and : [
          {mentions : { inq : [company.id] }},
          {mediaType : { inq : ["video/mp4", "audio/mpeg", "embed/audioboom", "video/youtube"] }}
        ]
          },
      order : "publishedAt desc"
      }


    const mediaAssets = await fetch(`https://api.voxmarkets.co.uk/v2/media/assets?filter=${JSON.stringify(mediaFilter)}`).then( res => res.json() ).then( assets => {
      this.setState({ mediaAssets : assets })
    });
    
    return { mediaAssets }
  };

  async componentDidMount() {
    await this.loadData();
    if (this.scroller)
      new PerfectScrollbar(this.scroller, {
        minScrollbarLength: 20,
        useBothWheelAxes: true,
        wheelSpeed: 0.6
      });
  }

  getTitle = asset => {
    if (
      this.props.type === "single" ||
      (this.props.type === "single-cover" &&
        asset &&
        asset.mediaType.startsWith("video"))
    ) {
      return "Video";
    } else if (
      this.props.type === "single" ||
      (this.props.type === "single-cover" &&
        asset &&
        asset.mediaType.startsWith("audio"))
    ) {
      return "Podcast";
    } else if (this.props.type === "box") {
      return "media";
    } else if (this.props.type === "vertical") {
      return "media";
    } else if (
      this.props.type === "horizontal" &&
      this.props.mediaType === "audio"
    ) {
      return "Podcasts";
    } else if (this.props.type === "horizontal") {
      return "Videos";
    } else if (
      this.props.type === "recent" &&
      this.props.mediaType === "audio"
    ) {
      return "Recent Podcast";
    } else if (this.props.type === "recent") {
      return "Recent media";
    }

    return "media";
  };

  render() {
    return (
      <VoxThemeProvider>
        {this.state.company && (
          <Widget
            style={{
              borderColor: `rgba(${this.props.color}, 1)`,
              background: `rgba(${this.props.bg}, 1)`
            }}
          >
            <Spacing horizonatal={0.6} vertical={0.5}>
              <Link
                block
                href={`//www.voxmarkets.co.uk/company/${this.props.ticker}`}
                target="_blank"
              >
                <Grid>
                  <Cell fit>
                    <CompanyCard
                      name={this.state.company.companyName}
                      logo={`https://img.voxmarkets.co.uk/72/companies/${this.state.company.id}.png`}
                      ticker={this.state.ticker}
                      color={this.props.color}
                    />
                  </Cell>
                  <Cell fill>
                    <Header
                      title={this.getTitle(this.state.mediaAssets && this.state.mediaAssets[0])}
                      color={this.props.color}
                    />
                  </Cell>
                </Grid>
              </Link>
              {this.props.type === "box" && this.state.mediaAssets && this.state.mediaAssets[0] && (
                <Spacing top={1}>
                  <MediaItem
                    mediaAsset={this.state.mediaAssets[0]}
                    color={this.props.color}
                    clipTitle
                    withCover
                  />
                </Spacing>
              )}
              {(this.props.type === "single" || this.props.type === "recent") &&
               this.state.mediaAssets && this.state.mediaAssets[0] && (
                 <Spacing top={1}>
                   <MediaItem
                     mediaAsset={this.state.mediaAssets[0]}
                     color={this.props.color}
                     clipTitle
                     withCover={this.props.mediaType !== "audio"}
                   />
                 </Spacing>
              )}

              {this.props.type === "single-cover" &&
               this.state.mediaAssets && this.state.mediaAssets[0] && (
                 <Spacing top={1}>
                   <MediaItem
                     mediaAsset={this.state.mediaAssets[0]}
                     color={this.props.color}
                     clipTitle
                     withCover
                   />
                 </Spacing>
              )}

              {this.props.type === "vertical" && this.state.mediaAssets && (
                <Spacing top={1} right={-0.6}>
                  <RatioBox
                    ratio="1/1"
                    rightPadding={0.6}
                    innerRef={node => {
                      this.scroller = node;
                    }}
                  >
                    <List spacing={1}>
                      {this.state.mediaAssets.map(asset => (
                        <li key={asset.id}>
                          <MediaItem
                            mediaAsset={asset}
                            color={this.props.color}
                            withCover
                          />
                        </li>
                      ))}
                    </List>
                  </RatioBox>
                </Spacing>
              )}

              {this.props.type === "horizontal" && this.state.mediaAssets && (
                <Spacing top={1}>
                  <Scroller
                    innerRef={node => {
                      this.scroller = node;
                    }}
                  >
                    <List horizontal spacing={1}>
                      {this.state.mediaAssets.map(asset => (
                        <li key={asset.id}>
                          <MediaItem
                            mediaAsset={asset}
                            clipTitle
                            width={this.props.playerWidth || "280px"}
                            color={this.props.color}
                          />
                        </li>
                      ))}
                    </List>
                  </Scroller>
                </Spacing>
              )}

              {this.props.type === "horizontal-recent" && this.state.mediaAssets && (
                <Spacing top={1}>
                  <Scroller
                    innerRef={node => {
                      this.scroller = node;
                    }}
                  >
                    <List horizontal spacing={1}>
                      {this.state.mediaAssets.map(asset => (
                        <li key={asset.id}>
                          <MediaItem
                            mediaAsset={asset}
                            clipTitle
                            width={this.props.playerWidth || "280px"}
                            color={this.props.color}
                            withCover
                          />
                        </li>
                      ))}
                    </List>
                  </Scroller>
                </Spacing>
              )}
            </Spacing>
          </Widget>
        )}
      </VoxThemeProvider>
    );
  }
}

MediaWidget.defaultProps = {
  color: "20,98,125"
};

export default MediaWidget;
